import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TrackVehicleRoutingModule } from './track-vehicle-routing.module';
import { TrackVehicleComponent } from './track-vehicle.component';


@NgModule({
  declarations: [TrackVehicleComponent],
  imports: [
    CommonModule,
    TrackVehicleRoutingModule,
    SharedModule,
  ]
})
export class TrackVehicleModule { }
